import api_config from '../config/api'

export default {
	getOurSpecialists(lang) {
		return api_config.get(`api/our_specialist/${lang}`)
	},
}
